(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('UnitMachineService', UnitMachineService);

    /** @ngInject */
    function UnitMachineService(HttpService) {
        return {
            getCategories,
            getCategoriesAdmin,
            postCategory,
            putCategory,
            removeCategory,
            getManufacturers,
            getManufacturersAdmin,
            postManufacturer,
            putManufacturer,
            removeManufacturer,
            getModels,
            getModelsAdmin,
            postModel,
            putModel,
            removeModel,
            getMaintenanceTypes,
            getByUnit,
            getMaintenances,
            post,
            put,
            remove,
            postMaintenance,
            removeMaintenance
        };

        function getCategories() {
            return HttpService.get('/unit-machines/categories');
        }

        function getCategoriesAdmin() {
            return HttpService.get('/unit-machines/categories/all');
        }

        function postCategory(data) {
            return HttpService.post('/unit-machines/categories', data);
        }

        function putCategory(data) {
            return HttpService.put('/unit-machines/categories', data);
        }

        function removeCategory(id) {
            return HttpService.delete(`/unit-machines/categories/${id}`);
        }

        function getManufacturers() {
            return HttpService.get('/unit-machines/manufacturers');
        }

        function getManufacturersAdmin() {
            return HttpService.get('/unit-machines/manufacturers/all');
        }

        function postManufacturer(data) {
            return HttpService.post('/unit-machines/manufacturers', data);
        }

        function putManufacturer(data) {
            return HttpService.put('/unit-machines/manufacturers', data);
        }

        function removeManufacturer(id) {
            return HttpService.delete(`/unit-machines/manufacturers/${id}`);
        }

        function getModels() {
            return HttpService.get('/unit-machines/models');
        }

        function getModelsAdmin() {
            return HttpService.get('/unit-machines/models/all');
        }

        function postModel(data) {
            return HttpService.post('/unit-machines/models', data);
        }

        function putModel(data) {
            return HttpService.put('/unit-machines/models', data);
        }

        function removeModel(id) {
            return HttpService.delete(`/unit-machines/models/${id}`);
        }

        function getMaintenanceTypes() {
            return HttpService.get('/unit-machines/maintenance-types');
        }

        function getByUnit(unitId) {
            return HttpService.get(`/unit-machines/unit/${unitId}`);
        }

        function getMaintenances(unitMachineId) {
            return HttpService.get(`/unit-machines/${unitMachineId}/maintenances`);
        }

        function post(data) {
            return HttpService.post('/unit-machines', data);
        }

        function put(data) {
            return HttpService.put('/unit-machines', data);
        }

        function remove(unitMachineId) {
            return HttpService.delete(`/unit-machines/${unitMachineId}`);
        }

        function postMaintenance(data) {
            return HttpService.post('/unit-machines/maintenances', data);
        }

        function removeMaintenance(maintenanceId) {
            return HttpService.delete(`/unit-machines/maintenances/${maintenanceId}`);
        }
    }
}());
